import { gql } from 'apollo-angular';

export const GET_DEFECT_HISTORY_BY_FACILITY = gql`
    query GetDefectHistory($userFacility: String!, $startDate: String!, $endDate: String!) {
        GetDefectHistory(UserFacility: $userFacility, StartDate: $startDate, EndDate: $endDate) {
            Success
            Message
            Data
        }
    }
`;